<template>
  <div class="col-form">
    <v-text-field v-model="draft.title" label="Section Title" placeholder="Enter section title" color="amber"
      :dense="inline" :outlined="!inline" class="mb-2" />

    <v-textarea v-model="draft.description" label="Description (optional)" placeholder="Enter description" color="amber"
      :dense="inline" :outlined="!inline" rows="2" auto-grow hide-details class="mb-3" />

    <!-- Actions for modal mode -->
    <div v-if="!inline" class="d-flex justify-end mt-4">
      <v-btn small text class="mr-2" @click="handleCancel">Cancel</v-btn>
      <v-btn light small color="amber" @click="handleSubmit">{{ isEditing ? 'Update' : 'Create' }}</v-btn>
    </div>
  </div>
</template>

<script>
import { groupModel, deepClone, toSlug } from './model'

const buildDraft = (item) => {
  const base = deepClone(groupModel)
  if (!item) return base
  return { ...base, ...deepClone(item) }
}

export default {
  name: 'ColForm',

  props: {
    // For modal mode: the group being edited (null for new)
    item: {
      type: Object,
      default: null,
    },
    // For inline mode: v-model binding
    value: {
      type: Object,
      default: null,
    },
    // Whether to use inline mode (real-time sync) vs modal mode (submit/cancel)
    inline: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      draft: buildDraft(this.inline ? this.value : this.item),
    }
  },

  computed: {
    isEditing() {
      return !!(this.item?.id || this.value?.id)
    },
  },

  watch: {
    // For modal mode: reset when item changes
    item: {
      handler(val) {
        if (!this.inline) {
          this.draft = buildDraft(val)
        }
      },
      immediate: false,
    },
    // For inline mode: sync with v-model
    value: {
      handler(val) {
        if (this.inline && val) {
          this.draft = buildDraft(val)
        }
      },
      deep: true,
    },
    // For inline mode: emit changes as user types
    draft: {
      handler(val) {
        if (this.inline) {
          this.$emit('input', {
            ...val,
            name: toSlug(val.title),
          })
        }
      },
      deep: true,
    },
  },

  methods: {
    handleSubmit() {
      if (!this.draft.title?.trim()) {
        return
      }
      this.$emit('submit', {
        ...this.draft,
        name: toSlug(this.draft.title),
      })
    },

    handleCancel() {
      this.$emit('cancel')
    },

    reset() {
      this.draft = buildDraft(this.item)
    },
  },
}
</script>

<style lang="scss" scoped>
.col-form {
  padding: 0;
}
</style>
